import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  // businessType 自助服务类型
  HELP_SELF_SERVICE_BUSINESSTYPE_REFUND: 1, //申请退货
  HELP_SELF_SERVICE_BUSINESSTYPE_EXCHANGE: 2, //申请换货
  HELP_SELF_SERVICE_BUSINESSTYPE_ORDER: 3, //修改订单
}, km({
    /*yeoman-template-point-1*/
}))
